class GoogleMapsInit {
    constructor() {
        this.map = window.google.maps.Map;
        this.marker = window.google.maps.Marker;
        this.infoWindow = window.google.maps.InfoWindow;
        this.event = window.google.maps.event;
    }

    getMap() {
        return this.map;
    }

    getMarker() {
        return this.marker;
    }

    getInfoWindow() {
        return this.infoWindow;
    }

    getEvent() {
        return this.event;
    }
}

export default GoogleMapsInit;
